(function () {
  function getCateringIds() {
    var el = document.getElementById('catering-product-ids');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function checkCartForUpsell() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var cateringIds = getCateringIds();
        var upsellEls = document.querySelectorAll('.cannoli-upsell');
        if (!upsellEls.length) return;

        var hasCatering = cart.items.some(function (item) {
          return cateringIds.indexOf(item.product_id) !== -1;
        });

        upsellEls.forEach(function (upsellEl) {
          var cannoliVariantId = upsellEl.getAttribute('data-variant-id');
          var hasCannoli = cart.items.some(function (item) {
            return String(item.variant_id) === String(cannoliVariantId);
          });
          upsellEl.style.display = (hasCatering && !hasCannoli) ? 'block' : 'none';
        });
      })
      .catch(function () {});
  }

  function addCannoli(btn) {
    var wrapper = btn.closest('.cannoli-upsell');
    var variantId = wrapper.getAttribute('data-variant-id');
    var qtyInput = wrapper.querySelector('.cannoli-upsell__qty-input');
    var quantity = parseInt(qtyInput.value, 10) || 1;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        btn.textContent = 'Added!';

        // Update the cart in place via Horizon's event system rather than
        // reloading. A reload tears down any in-flight cart requests (e.g. the
        // free-gift script's /cart/change.js calls) mid-teardown, which is what
        // was causing the free donuts to disappear.
        return import('@theme/events')
          .then(function (module) {
            return fetch('/cart.js')
              .then(function (res) { return res.json(); })
              .then(function (cart) {
                document.dispatchEvent(new module.CartUpdateEvent(cart, 'cannoli-upsell', {
                  itemCount: cart.item_count,
                  source: 'cannoli-upsell',
                  sections: {}
                }));
              });
          })
          .catch(function () {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { data: { itemCount: quantity, source: 'cannoli-upsell' } }
            }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          });
      })
      .then(function () {
        if (qtyInput) qtyInput.value = 1;
        return checkCartForUpsell();
      })
      .catch(function () {
        btn.textContent = 'Error';
      })
      .finally(function () {
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = 'Add';
        }, 1500);
      });
  }

  function changeQty(btn, delta) {
    var wrapper = btn.closest('.cannoli-upsell');
    var qtyInput = wrapper.querySelector('.cannoli-upsell__qty-input');
    if (!qtyInput) return;
    var current = parseInt(qtyInput.value, 10) || 1;
    var next = current + delta;
    if (next < 1) next = 1;
    qtyInput.value = next;
  }

  function init() {
    checkCartForUpsell();

    document.body.addEventListener('click', function (e) {
      var minusBtn = e.target.closest('.cannoli-upsell__qty-minus');
      var plusBtn = e.target.closest('.cannoli-upsell__qty-plus');
      var addBtn = e.target.closest('.cannoli-upsell__add');

      if (minusBtn) changeQty(minusBtn, -1);
      if (plusBtn) changeQty(plusBtn, 1);
      if (addBtn) addCannoli(addBtn);
    });

    setInterval(checkCartForUpsell, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();